import { formatVerbatimMoneyCurrency } from '@shared/utils/formatMoneyDisplay';

interface Props {
    total: string;
    accountCount: number;
    currency: string;
    roundingMode: string;
}

export function DealerFundStatementTotals({ total, accountCount, currency, roundingMode }: Props) {
    const mode = roundingMode.replace(/_/g, '-');
    return (
        <div className="space-y-3">
            <dl aria-label="Fund statement totals" className="grid gap-4 sm:grid-cols-2">
                <div>
                    <dt className="text-sm text-mp-muted">Total fund balance</dt>
                    <dd className="text-2xl font-semibold tabular-nums">{formatVerbatimMoneyCurrency(total, currency)}</dd>
                </div>
                <div>
                    <dt className="text-sm text-mp-muted">Agreements with a fund account</dt>
                    <dd className="text-2xl font-semibold tabular-nums">{accountCount}</dd>
                </div>
            </dl>
            <div className="space-y-1 text-xs text-mp-muted">
                <p>Agreements are grouped by the nightly ledger sync. An agreement activated since the last sync is not included yet.</p>
                <p>
                    Amounts in {currency}, rounded to 2 decimal places ({mode}). Each row is rounded on its own, so the rows need not add up exactly to the total.
                </p>
                <p>The total is the sum of settled ledger balances. It has not been reconciled against the external ledger provider's own total for this set.</p>
                <p>Payments still being processed are not included. A negative balance means the fund is in arrears.</p>
            </div>
        </div>
    );
}
